import React from 'react';
import { Button, Modal, Alert, Container } from 'react-bootstrap';

function Delete_Popup(props) {
    return (
        <Modal
            show={props.show}
            onHide={props.onHide}
            centered
            backdrop="static"
            size="md"
        >
            <Modal.Header closeButton>
                <Modal.Title className="text-danger">
                    Delete patient {props.patient_id}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="py-4">
                <Container>
                    <p className="mb-3 fs-5">
                        Are you sure you want to delete this patient?
                    </p>

                    <Alert variant="warning">
                        <strong>Warning:</strong> This action cannot be undone.
                    </Alert>
                </Container>
            </Modal.Body>

            <Modal.Footer>
                <Button
                    variant="secondary"
                    onClick={props.onHide}
                    className="px-3"
                >
                    Close
                </Button>
                <Button
                    variant="danger"
                    onClick={props.onDelete}
                    className="px-3"
                >
                    Delete
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default Delete_Popup;